import React from 'react';

import { Grid, makeStyles } from '@material-ui/core';
import i18n from 'i18n';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import CloseIcon from '@material-ui/icons/Close';
import Button from 'components/Button';
import { EnvironmentFields } from 'modules/environments/interfaces';
import TitleBehavior from 'containers/Environments/Configuration/FormBehavior/TitleBehavior';
import styles, { overrideTitleBehavior } from './styles';
import ChangeAccount from './ChangeAccount';
import MigrateHistory from './MigrateHistory';

interface Props {
  environmentSelected: EnvironmentFields | null;
}

const useStyles = makeStyles(styles);

const MigrateEnvironment = ({ environmentSelected }: Props) => {
  const classes = useStyles();
  const [changeAccount, setChangeAccount] = React.useState(false);
  return (
    <>
      <Grid
        container
        justify="flex-start"
        alignItems="center"
        className={classes.buttons}
      >
        <Grid item xs={12}>
          <TitleBehavior
            overrideClasses={overrideTitleBehavior}
            title={i18n.t('MIGRATE_ENVIRONMENT_KEY')}
            subtitle={i18n.t('MIGRATE_ENVIRONMENT_BUTTON_BELLOW_KEY')}
          />
          {!changeAccount ? (
            <Button
              variant="outlined"
              startIcon={<SyncAltIcon />}
              className={classes.changeButton}
              onClick={() => {
                setChangeAccount(!changeAccount);
              }}
            >
              {i18n.t('MIGRATE_ENVIRONMENT_BUTTON_KEY')}
            </Button>
          ) : (
            <Button
              variant="outlined"
              startIcon={<CloseIcon />}
              className={classes.cancelButton}
              onClick={() => {
                setChangeAccount(!changeAccount);
              }}
            >
              {i18n.t('CANCEL_KEY')}
            </Button>
          )}
          {changeAccount && (
            <Grid container className={classes.container}>
              <ChangeAccount environmentSelected={environmentSelected} />
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid container>
        <MigrateHistory />
      </Grid>
    </>
  );
};

export default MigrateEnvironment;
